jQuery(function ($) {
  var hamburger = $('.hamburger');
  var linkWrap = $('.main-navbar .list');
  var win = $(window).width();
  $(document).ready(function () {
    $(linkWrap).on({
      mouseenter: function () {
        var windowWidth = $(window).width();
        if (windowWidth > 992) {
          $(this).addClass('active');
        }
      },
      mouseleave: function () {
        var windowWidth = $(window).width();
        if (windowWidth > 992) {
          $(this).removeClass('active');
        }
      },
      click: function () {
        var windowWidth = $(window).width();
        if (windowWidth < 991) {
          $(linkWrap).not(this).removeClass('active');
          $(this).toggleClass('active');
        }
      }
    });
    if ($(window).on('resize', function () {
      $('.main-navbar .list').removeClass('active');
    }));
  });
  $(hamburger).on('click', function () {
    $("body").toggleClass("nav-active");
  })

  $(window).on("resize", function () {
    var desktopUp = $(window).width();
    if (desktopUp < 991) {
      $(".list").removeClass("active");
    }
    if (desktopUp > 991) {
      $("body").removeClass("nav-active");
      $(".list").removeClass("active");
    }
  });
  $(document).ready(function () {
    var lastScroll = 0;
    $(document).ready(function ($) {
      $(window).scroll(function () {
        if ($(this).scrollTop() > 10) {
          $("body").addClass("afterscroll");
        }
        else {
          $("body").removeClass("afterscroll");
        }
        setTimeout(function () {
          const body = document.body,
            html = document.documentElement;
          const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

          // Calculate the distance scrolled from the bottom
          const distanceFromBottom = height - (window.innerHeight + window.pageYOffset);
          var scroll = $(window).scrollTop();
          if (scroll > lastScroll) {
            $("body").addClass("shift");
          }
          else if ((scroll < lastScroll) && (distanceFromBottom >= 30)) {
            $("body").removeClass("shift");
          }
          lastScroll = scroll;
        }, 100);
      });
    });
    // const myTimeout = setTimeout(pageLoad, 5000);
    function pageLoad() {
      $("body").addClass('page-ready');
    }
    pageLoad()

  });
  $(document).ready(function () {
    $(".text-with-image .col-three .action").mouseenter(function () {
      $(this).parent().addClass("hover");
    });
    $(".text-with-image .col-three .action").mouseleave(function () {
      $(this).parent().removeClass("hover");
    });
    $("body .search-opener").on('click', function () {
      $("body .main-navbar").toggleClass("search-active");
      document.getElementById("search").focus();
    });
  });
  $(document).on("click", document, function (e) {
    $("body .main-navbar").removeClass("search-active");
  });
  $(document).on("click", ".main-navbar", function (event) {
    event.stopPropagation();
  });
  $(document).on("click", "body .search-opener", function (event) {
    event.stopPropagation();
  });
});